export enum ServiceType {
  REGULAR = "REGULAR",
  SCHOOL = "SCHOOL",
  CORPORATE = "CORPORATE",
  OTHERS = "OTHERS",
  DISCRETIONARY = "DISCRETIONARY"
}
